<template>
  <div>
    <v-card>
      <v-card-title>Asignar Cliente</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-combobox            
                v-model="cliente"
                :items="clientes"
                item-text="name"
                item-value="id"
                label="Cliente"
                append-icon="mdi-handshake"
                return-object
                :disabled="disableAll"
            ></v-combobox>
          </v-col>
        </v-row>                
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer
        ><v-btn :disabled="disableAll" color="primary" outlined @click="asignar()">
          Asignar</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </div>
</template>

<script>
import Waiting from "./Waiting.vue";
import apicon from "../plugins/apicon";
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Waiting,
  },
  created: function () {},
  data() {
    return {      
      clientes: [],
      cliente: null,      
      overlay: false,
      disableAll: false,
    };
  },
  methods: {
    fillClientes: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + "usuario").then((result) => {
        this.clientes = result;
      });
    },
    asignar: async function (id) {
      if (this.cliente != null) {                  
            this.overlay = true;
            await apicon
              .saveDataApi(apicon.getApiBaseUrl() + "asignarcliente", {
                id: this.id,
                cuenta: this.cliente.codigo,
                id_usuario: this.cliente.id,                
              })
              .then((result) => {
                this.overlay = false;
                this.disableAll = true;
                this.$swal(result.message);
              });           
      } else {
        this.$swal("Por favor seleccione un cliente...");
      }
    },
  },
  mounted: function () {
    apicon.setAuthHeaders();
    this.fillClientes();
  },
};
</script>